import request from "@/utils/request";


// POST http://localhost:1012/web/user/file
//用户文件表的新增
export function addUserFile(data) {
    return request({
        url: '/web/user/file',
        method: 'post',
        data: data
    })
}


// POST http://localhost:1012/web/user
export function addUser(data) {
    return request({
        url: '/web/user',
        method: 'post',
        data: data
    })
}

// PUT http://localhost:1012/web/user/changePassword
// 忘记密码
export function forgetThePassword(data) {
    return request({
        url: '/web/user/forgetThePassword',
        method: 'put',
        data: data
    })
}

// PUT http://localhost:1012/web/user/changePassword
// 修改密码
export function changePassword(data) {
    return request({
        url: '/web/user/changePassword',
        method: 'put',
        data: data
    })
}


//GET http://localhost:1012/web/user/info/{{userId}}
// 查询用户信息和文件
export function getUserInfo(data) {
    return request({
        url: '/web/user/info/'+data,
        method: 'get',
    })
}

// PUT http://localhost:1012/web/user
// 修改用户信息

export function updateUserInfo(data) {
    return request({
        url: '/web/user',
        method: 'put',
        data: data
    })
}


//DELETE http://localhost:1012/web/user/file/removeUserFile/{id}
//删除用户文件表 以及 服务器文件

export function removeUserFile(id) {
    return request({
        url: '/web/user/file/removeUserFile/'+id,
        method: 'delete',
    })
}


// 查询用户信息和文件
export function getInfo(data) {
    return request({
        url: '/web/user/'+data,
        method: 'get',
    })
}
